import React from 'react';
import { SuspenseWrapper } from './SuspenseWrapper';
import useGoBackOrGoHome from './redirects/useGoBackOrGoHome';
import { useAuthContext } from '../contexts/AuthContext/AuthContext';
import { CookieConsentData } from '../consent/types';
import { useAppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';
import { getCookieConsentData } from '../consent/getCookieConsentData';
import { useGeolocation } from '../hooks/useGeolocation';
import useSWRImmutable from 'swr/immutable';
import {
  getInstructionsKeyGetter,
  htmlContentFetcher,
} from '../../service/text-fetchers';

const SettingsViewLazy = React.lazy(
  () => import('../SettingsView/SettingsViewContainer')
);

const SettingsRoute: React.FC = () => {
  const goBackOrGoHomeRef = React.useRef(useGoBackOrGoHome());
  const { user } = useAuthContext();
  const { data: currentAddress } = useGeolocation();
  const { languageCode } = useAppFeaturesContext();
  const [consentData, setConsentData] =
    React.useState<CookieConsentData | null>();
  const [waitTarget, setWaitTarget] = React.useState<Promise<unknown>>();

  const getKey = getInstructionsKeyGetter(languageCode);

  const { isLoading } = useSWRImmutable(getKey, htmlContentFetcher);

  React.useEffect(() => {
    const consentPromise = getCookieConsentData(
      languageCode,
      goBackOrGoHomeRef.current
    ).then(data => setConsentData(data));

    setWaitTarget(consentPromise);
  }, [currentAddress, languageCode, user]);

  return (
    <SuspenseWrapper promiseToWait={waitTarget} isLoading={isLoading}>
      {consentData && (
        <SettingsViewLazy
          consentUiActions={consentData.actions}
          consentUiOptions={consentData.uiElementOptions}
          consentInfo={consentData.info}
        />
      )}
    </SuspenseWrapper>
  );
};

export default SettingsRoute;
